// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1wywD","label":"CategoryService_label__3SPCc","location":"CategoryService_location__38izd"};